export default "__VITE_ASSET__7F3NFgpd__"